import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FocusOnElementDirective } from './focus-on-element.directive';

@NgModule({
  imports: [CommonModule],
  declarations: [FocusOnElementDirective],
  exports: [FocusOnElementDirective]
})
export class IdpFocusOnElementDirectiveModule {}
